<template>
  <el-dialog
             title="SKU列表"
             :visible.sync="dialogVisible"
             custom-class="importDialog"
             @close="hide"
             :close-on-click-modal="false"
             :close-on-press-escape="false">
    <el-form :model="form"
             :rules="rules"
             ref="refDialog"
             label-width="100px">
      <el-row>
        <el-col :span="6">
          <el-form-item label-width
                        prop="sku"
                        label="SKU">
            <el-input v-model="form.query.sku"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label-width
                        prop="title"
                        label="标题">
            <el-input v-model="form.query.title"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label-width
                        prop="title"
                        label="是否设置">
            <el-select
              v-model="form.query.remark"
              placeholder="请选择是否设置SKU"
              style="width: 90%">
              <el-option v-for="(item, index) in rmkSku" :key="index" 
                         :label="item.label" :value="item.value">{{item.label}}</el-option>
            </el-select>
            <!-- <el-input v-model="form.query.remark"></el-input> -->
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-card class="button-box">
            <el-button @click="handleSearch">搜索</el-button>
            <el-button @click="handleSet"
                        type="primary">设置</el-button>
            <el-button @click="handleDel"
                        type="danger">删除</el-button>
          </el-card>
        </el-col>
      </el-row>
    </el-form>
    <!-- el-table -->
    <el-table v-loading="loading"
              height="calc(100vh - 100px)"
              :data="tableData"
              border>
      <el-table-column width="100" align="center"
                       header-align="center"
                       label="选择">
                       <template slot-scope="scope">
                         <el-checkbox v-model="scope.row.checked"></el-checkbox>
                       </template>
                       </el-table-column>
      <el-table-column prop="sku"
                       align="center"
                       header-align="center"
                       label="SKU"></el-table-column>
      <el-table-column prop="title"
                       align="center"
                       header-align="center"
                       label="标题"></el-table-column>
      <el-table-column prop="profession"
                       align="center"
                       header-align="center"
                       label="行业"></el-table-column>
      <el-table-column prop="business"
                       align="center"
                       header-align="center"
                       label="商家"></el-table-column>
      <el-table-column prop="store"
                       align="center"
                       header-align="center"
                       label="店铺"></el-table-column>
      <el-table-column prop="platform_from"
                       align="center"
                       header-align="center"
                       label="平台"></el-table-column>
      <el-table-column prop="platform_from"
                       align="center"
                       header-align="center"
                       label="是否设置">
                       <template slot-scope="scope">
                         <el-switch
                            v-model="scope.row.remark" 
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            disabled></el-switch>
                       </template>
                       </el-table-column>
      <el-table-column prop=""
                       align="center"
                       header-align="center"
                       label="操作">
                       <template slot-scope="scope">
                         <div class="edit" @click="editBtn(scope.row)">编辑</div>
                       </template>
                       </el-table-column>
      </el-table>
      <el-card>
        <el-row class="pagation-row">
          <el-pagination background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="form.pagenum"
              :page-size="form.pagesize"
              :page-sizes="[10, 20, 50, 100]"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"></el-pagination>
        </el-row>
      </el-card>
      <SkuSetDialog ref="refSkuSetDialog" @getrestSkuList="getSkuList"
                     :queryInfo="setquery" :skus="ruleForm.skus" />
  </el-dialog>
</template>

<script>
// import { getplatlists, getptnlists, getshoplists } from '@/common/mixins/select'
import { rules } from './data.js'
let _rule = JSON.parse(JSON.stringify(rules))
import SkuSetDialog from './skusetdialog'

export default {
  components: { SkuSetDialog },
  props: { queryInfo: Object },
  data() {
    return {
      dialogVisible: false,
      query: this.queryInfo,
      setquery: {},
      form: {
        pagenum: 1,
        pagesize: 20,
        query: {
          sku: '',
          title: '',
          remark: ''
        }
      },
      rules: _rule,
      loading: false,
      tableData: [],
      total: 0,
      rmkSku: [
        {
          label: '是',
          value: true
        },
        {
          label: '否',
          value: false
        }
      ],
      ruleForm: {
        skus: [],
        id: []
      }
    }
  },
  created() {
    
  },
  methods: {
    show() {
      this.form.query.business = this.query.business
      this.form.query.profession = this.query.profession
      this.form.query.store = this.query.store
      this.form.query.remark = ''
      this.getSkuList()
      this.dialogVisible = true
    },
    hide() {
      this.dialogVisible = false
      this.form.query = {
        sku: '',
        title: '',
      }
      this.$refs.refDialog.resetFields()
    },
    handleSearch() {
      this.getSkuList()
    },
    handleSet() {
      this.getSkuChk()
      if (this.ruleForm.skus.length > 0) {
        this.setquery = {
          business: this.form.query.business,
          profession: this.form.query.profession,
          store: this.form.query.store,
          skus: this.ruleForm.skus,
          remark: '',
          edit: 0
        }
        this.$refs.refSkuSetDialog.show(this.setquery)
      } else {
        this.$message.error('请选择要设置的SKU')
      }
    },
    handleDel() {
      this.getSkuChk()
      if (this.ruleForm.id.length > 0) {
        this.$confirm('是否删除SKU设置，继续？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          this.loading = true
          let query = {
            url: 'deleteSku',
            title: '删除',
            method: 'post'
          }
          let { data, err } = await this.axiosApi(query, { id: this.ruleForm.id })
          this.loading = false
          if (data && data.data.data && data.data.meta.status == 200) {
            this.$message.success(data.data.data)
            this.getSkuList()
          }
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
      }else{
        this.$message.error('请选择要删除的SKU')
      }
    },
    async getSkuList() {
      let query = {
        url: 'ItemList',
        title: '列表',
        method: 'post'
      }
      this.tableData = []
      this.ruleForm.skus = []
      this.ruleForm.id = []
      this.loading = true
      let { data, err } = await this.axiosApi(query, this.form)
      this.loading = false
      if (data && data.data.meta && data.data.meta.status === 200) {
        this.tableData = data.data.data.data
        this.total = parseInt(data.data.data.total)
      }
    },
    async editBtn(row) {
      this.setquery = {
        business: this.form.query.business,
        profession: this.form.query.profession,
        store: this.form.query.store,
        skus: [row.sku],
        remark: row.remark,
        edit: 1
      }
      this.$refs.refSkuSetDialog.show(this.setquery)
    },
    handleSizeChange(val) {
      this.form.pagesize = val
      this.getSkuList()
    },
    handleCurrentChange(val) {
      this.form.pagenum = val
      this.getSkuList()
    },
    getSkuChk() {
      this.ruleForm.skus = []
      this.tableData.forEach(item => {
        if(!item.checked) return
        this.ruleForm.skus.push(item.sku)
        this.ruleForm.id.push(item.id)
      })
    },
  },
  watch: {
    
  },
  filters: {
  },
}
</script>
<style lang="scss" scoped>
.el-dialog__wrapper >>> {
  .importDialog {
    width: 85%;
  }
}
.edit{
  color: blue;
  cursor: pointer;
  text-decoration: underline;
}
</style>


// WEBPACK FOOTER //
// src/views/statistics/supply/skudialog.vue